import { GET_USER_DETAIL } from '../Enums/User.Enums';
import { setUser } from 'Telemetry/telemetry.service';

const initState = {
	userName: '',
	isSupervisor: false
};

export default function user(state = initState, action) {
	let updated = {};
	let { type, payload } = action;

	if (type === GET_USER_DETAIL) {
		updated = {
			...state,
			userName: payload.data[0].userName,
			isSupervisor: payload.data[0].isSupervisor
		};
	} else {
		return state;
	}

    setUser(payload.data[0]);
	return updated;
}
